import React from 'react'
import { Link } from 'react-router-dom'
import {
  MdOutlineHome
} from 'react-icons/md'
import {
  AiOutlineFire,
  AiOutlineCrown
} from 'react-icons/ai'
import {
  BiCalendar
} from 'react-icons/bi'

import './Sidebar.css'

const SidebarData = [
  {
    title:'Home',
    icon: <MdOutlineHome />,
    link: "/"
  },
  {
    title:'Popular',
    icon: <AiOutlineFire />,
    link: "/popular"
  },
  {
    title:'Recent',
    icon:<BiCalendar />,
    link: "/recent"
  },
  {
    title:'Best',
    icon: <AiOutlineCrown />,
    link: "/best"
  },
  
]
const Sidebar = () => {
  return (
    <div className='sidebar'>
      <ul className='sidebar-list'>
        {SidebarData.map((data, index) => {
          return(
            <Link key={index} to={data.link}>
              <li>
                <div className='list-icon'>{data.icon}</div>
                <div className='list-title'>
                  {data.title}
                </div>
              </li>
            </Link>
            
          )
        })}
      </ul>
    </div>
  )
}

export default Sidebar